import React, { useContext } from "react";
import Context from "../context";
import { Pagination, Stack } from "@mui/material";
import { getAllSalesInvoices } from "../service";

const SalesInvoicesPagination = () => {
    const context = useContext(Context);

    return(
        <>
            {!context.state.is_loading_sales_invoices ? (
                <Stack 
                    spacing={2} 
                    className="mb-3" 
                    style={{
                        alignItems: 'center',
                        display: 'flex',
                        justifyContent: 'center'
                    }}      
                >
                    <Pagination 
                        count={context.state.total_pages} 
                        page={context.state.current_page_si} 
                        onChange={(event, newPage) => getAllSalesInvoices(newPage, context.dispatch)}
                    />
                </Stack>
            ) : null }
        </>
    );
}

export default SalesInvoicesPagination;